var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-2 mb-10",attrs:{"align":"center","justify":"space-around"}},[_c('v-progress-circular',{attrs:{"width":2,"size":40,"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }